import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectAccountsListItems } from "../../../../../../redux/accounts/selector";
import { accounts } from "../../../../../../redux/accounts/action";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../../redux/library/selector";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementAccounts = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const accountsItems = useSelector(selectAccountsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'AccountNumber', headerName: 'AccountNumber', searchField: 'AccountNumber', sortable: true, filter: true, filterType: 'text' },
      { field: 'Email', headerName: 'Email', searchField: 'Email', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'TypeId', headerName: 'Type',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.Type, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: true,
        filterType: 'text',
        filterBy: libraryData?.result?.Type,
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'Phone', headerName: 'Phone' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }

    ]);
  }

  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Select', value: "select", enumLists: libraryData?.result?.Type
  },
  {
    name: 'Date', value: "date"
  }]

  const fetchAccounts = () => {

    dispatch(accounts.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
      entity: 'accounts',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }));
  }

  useEffect(() => {
    createColumnDefs()
    fetchAccounts()
  }, [pageData, pageSize])

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Account</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,

      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    }
  ];

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(accounts.delete({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/delete`,
      entity: 'accounts',
      jsonData: {
        Context: {},
        Records: [{
          Id: data?.Id,
          IsDeleted: true,
          IsDeregister: false
        }]
      }
    })).then(() => {
      dispatch(accounts.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
        entity: 'accounts',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  const handleReloadData = () => {
    fetchAccounts();
  }
  const handleAccountPermanentlyDelete = async (data: any) => {
    await dispatch(accounts.delete({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/delete`,
      entity: 'accounts',
      jsonData: {

        Context: {},
        Records: [{
          Id: data?.Id,
          IsDeregister: true
        }]

      }
    }))
    await fetchAccounts();
  }
  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(accounts.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
      entity: 'accounts',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }



  return (
    <>
      {accountsItems?.isLoading ?
        <PageLoader /> :
        <Table columnData={columnDefs}
          rowData={accountsItems?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={accountsItems?.result?.pagination}
          onEdit={handleEdit} onDelete={handleDelete}
          enableFilter={true} onSearch={handleSearch}
          IsAccountMoreActions={true}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          handleAccountPermanentlyDelete={handleAccountPermanentlyDelete}
          additionButtons={additionButtons}
          headingName="Accounts" />
      }
    </>

  );
};

export default ManagementAccounts;
